import * as React from "react"

export default function BuggyIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.615 10.489a2.717 2.717 0 110 5.434 2.717 2.717 0 010-5.434zm2.841-6.407l4.817.754c.35.055.665.244.88.526l1.86 2.443 3.283.727.094.034a.376.376 0 01.184.226l.277.935c.089.302.093.624.012.928l-.063.235a2.712 2.712 0 011.302 2.316 2.717 2.717 0 11-1.997-2.618l.034-.126a.967.967 0 00.029-.288l-2.212-.246-1.71 2.905a.375.375 0 01-.323.184H7.132a.375.375 0 01-.317-.172L4.866 9.793l-3.345-.637a.376.376 0 01-.304-.37V8.41c0-.1.04-.195.11-.266l.56-.56a.376.376 0 01.27-.11l1.094.014 2.864-3.282.07-.064a.377.377 0 01.271-.06zm-2.84 7.157a1.967 1.967 0 100 3.934 1.967 1.967 0 000-3.934zm12.769 0a1.967 1.967 0 10.866.203.37.37 0 01-.102-.05 1.961 1.961 0 00-.764-.153zM2.04 8.49l3.126.597.073.021c.07.03.131.08.173.145l1.926 3.014h5.37l1.727-2.928.03-.045a.375.375 0 01.334-.137l2.173.241-.054-.181-3.03-.671-.687.53a.625.625 0 00-.244.495v1.31a.376.376 0 01-.458.367l-2.784-.632a.377.377 0 01-.179-.097L7.242 8.291l-4.937-.065-.265.264zm5.689-.773l2.252 2.19 2.226.505V9.57c0-.427.199-.83.537-1.09l.53-.409-1.717-2.256a.626.626 0 00-.4-.24L6.92 4.914l.809 2.804zM4.235 7.5l2.66.035-.667-2.32L4.235 7.5z"
        fill={props.fill}
      />
    </svg>)
}